import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
}

export const useCleanupArchivedBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      await request({
        path: `batches/${batchId}/cleanup`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success(`Batch was cleaned successfully!`);
    },
    onError: (error) => {
      showErrorToast(error, 'Error cleaning the batch!');
    },
  });
};
